import React, { useState, useRef, useEffect } from 'react'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Unstable_Grid2'
import MostImportant from '../Questions/MostImportant'
import HowMuch from '../Questions/HowMuch'
import Timeline from '../Questions/Timeline'
import ElectricBills from '../Questions/ElectricBills'
import Stories from '../Questions/Stories'
import GrantInterest from '../Questions/GrantInterest'
import Eircode from '../Questions/Eircode'
import Name from '../Questions/Name'
import Email from '../Questions/Email'
import Phone from '../Questions/Phone'
import Invalid from '../Invalid'
import Calculating from '../Calculating'
import ProgressBar from 'react-bootstrap/ProgressBar'
import * as api from '../../config/api/GuestAPI'
import { eircodesToCounty, validEmail } from '../../config/constants/Constants'
import { calculateFormProgress, redirect, solarRedirect } from '../../config/helpers/Helper'
import OptionsQuestion from '../Questions/OptionsQuestion'
// Icons
import Before2011 from '../../resources/images/insulation/ee-before2011.png'
import After2011 from '../../resources/images/insulation/ee-after2011.png'
import TerracedHouse from '../../resources/images/insulation/ee-terrace.png'
import DetachedHouse from '../../resources/images/insulation/ee-detached.png'
import SemiDetached from '../../resources/images/insulation/ee-semidetached.png'
import Apartment from '../../resources/images/insulation/ee-apartment.png'
import AtticInsulation from '../../resources/images/insulation/ee-roof-insulation.png'
import WallInsulation from '../../resources/images/insulation/ee-cavitywall.png'
import AtticWallInsulation from '../../resources/images/insulation/ee-roof-and-wall.png'
import Unsure from '../../resources/images/insulation/ee-unsure.png'
import SprayFoam from '../../resources/images/insulation/ee-sprayfoam.png'
import RollOut from '../../resources/images/insulation/ee-attic-roll.png'
import CavityWall from '../../resources/images/insulation/ee-cavitywall.png'
import External from '../../resources/images/insulation/ee-external-insulation.png'
import Internal from '../../resources/images/insulation/ee-internal-insulation.png'
import { onError, logInvalidSubmission } from '../../config/lib/errorLib'

const wait = t => new Promise((resolve, reject) => setTimeout(resolve, t))

export default function DataCaptureForm(props) {
    const [stage, setStage] = useState(0)
    const [loading, setLoading] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [invalid, setInvalid] = useState()
    const [invalidReason, setInvalidReason] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [eircodeError, setEircodeError] = useState(false)
    // insulation details
    const [homeBuilt, setHomeBuilt] = useState('')
    const [homeType, setHomeType] = useState('')
    const [insulationArea, setInsulationArea] = useState('')
    const [atticInsulationType, setAtticInsulationType] = useState([])
    const [wallInsulationType, setWallInsulationType] = useState([])
    // personal details
    const [eircode, setEircode] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [privacyPolicy, setPrivacyPolicy] = useState('')
    // A/B Testing
    //const [formVariant, setFormVariant] = useState(null)

    const dcForm = useRef(null)

    async function submitForm(e) {
        setLoading(true)
        if (e) {
            e.preventDefault()
        }

        const details = {
            homeBuilt,
            homeType,
            insulationArea,
            atticInsulationType: atticInsulationType.join(', '),
            wallInsulationType: wallInsulationType.join(', '),
            eircode,
            firstName,
            lastName,
            email,
            phone,
            privacyPolicy: true
        }
        console.log('submit details: ', details)
        
        try {
            let ip = await api.getIp()
            let response = await api.submitEeInsulationForm(details, ip)

            // Add delay before redirect
            await wait(2000)
            
            if (response.isValid || firstName.toLowerCase() === 'test') {
                let provider = response.companyId ? response.companyId.toLowerCase() : ''
                console.log('provider: ', provider)
                solarRedirect('https://energyefficiency.ie/insulation-recommendation', provider, response.hashedName, response.hashedEmail)
                //solarRedirect('https://energyefficiency.ie/details-submitted', provider, response.hashedName, response.hashedEmail)
            }
            else {
                handleInvalidResponse(response)
            }
        } catch(error) {
            onError(error)
            console.error('Error submitting form: ', error)
        }
    }

    function handleInvalidResponse(response) {
        try {
            // log invalid submission with reason in sentry
            logInvalidSubmission(response.invalidReason, {
                name: `${firstName} ${lastName}`,
                email,
                phone
            }, {
                site: 'energyefficiency.ie',
                form: 'insulation'
            })
        } catch(error) {
            onError(error)
            console.error('Error logging invalid submission: ', error)
        }
        switch (response.invalidReason) {
            case 'Profanity':
            case 'Fake Name':
            case 'Famous Name':
                // Optional: Send troll details
                // const trollResponse = await api.sendTrollDetails(details.firstName, details.lastName, details.email, details.phone, response.invalidReason)
                // console.log('Troll response:', trollResponse)
                redirect('https://youtu.be/GM-e46xdcUo?t=28')
                break
            default:
                setInvalid(true)
                if (['Phone number prefix', 'Phone number repeat', 'Phone number sequential'].includes(response.invalidReason)) {
                    setInvalidReason('Phone')
                } 
                else if (response.invalidReason.includes('Duplicate in last')) {
                    setInvalidReason('Duplicate')
                }
                setLoading(false)
        }
    }

    function checkEmail() {
        let trimmed = email.trim()
        console.log('trimmed email: ', trimmed)
        if (validEmail.test(trimmed)) {
            updateStage(stage + 1)
            setEmailError(false)
        }
        else {
            setEmailError(true)
        }
    }

    function updateStage(newStage) {
        setStage(newStage)
        //dcForm.current.scrollIntoView()
    }

    function checkEircode() {
        setButtonLoading(true)
        let county = null
        let prefix = eircode.trim().substring(0, 3).toUpperCase();
        console.log('prefix: ', prefix);
        if (eircodesToCounty.hasOwnProperty(prefix)) {
            county = eircodesToCounty[prefix];
        }
        if (county && county.length) {
            updateStage(stage + 1) 
            setEircodeError(false)
        }
        else {
            setEircodeError(true)
        }
        setButtonLoading(false)
    }

    function nextStage(answer = null) {
        if (stage === 2) {
            // Store insulationArea and control the path forward
            if (answer) setInsulationArea(answer);
    
            if (answer === 'Attic insulation') {
                setStage(3);
                return;
            } else if (answer === 'Wall insulation') {
                setStage(4);
                return;
            } else if (answer === 'Attic & wall insulation') {
                setStage(3); // go to attic first
                return;
            } else if (answer === 'Not sure yet') {
                setStage(5);
                return;
            }
        }
    
        if (stage === 3 && insulationArea === 'Attic & wall insulation') {
            setStage(4); // go to wall next
            return;
        }
    
        if (stage === 3 && insulationArea === 'Attic insulation') {
            setStage(5);
            return;
        }
    
        if (stage === 4) {
            setStage(5);
            return;
        }
    
        if (stage === 5) {
            checkEircode();
            return;
        }
    
        if (stage === 7) {
            checkEmail();
            return;
        }
    
        setStage(stage + 1);
    }    

    function previousStage() {
        if (stage === 5) {
            if (insulationArea === 'Wall insulation') {
                setStage(4); // go back to wall
                return;
            } else if (insulationArea === 'Attic insulation') {
                setStage(3); // go back to attic
                return;
            } else if (insulationArea === 'Attic & wall insulation') {
                setStage(4); // go back to wall first
                return;
            } else if (insulationArea === 'Not sure yet') {
                setStage(2); // skip both attic & wall
                return;
            }
        }
    
        if (stage === 4) {
            if (insulationArea === 'Wall insulation') {
                setStage(2); // skip attic
                return;
            } else if (insulationArea === 'Attic & wall insulation') {
                setStage(3); // go back to attic
                return;
            }
        }
    
        if (stage === 3) {
            if (insulationArea === 'Attic insulation' || insulationArea === 'Attic & wall insulation') {
                setStage(2);
                return;
            }
        }
    
        setStage(stage - 1);
    }    
    

    function checkNextDisabled() {
        if (stage === 0) {
            return !homeBuilt
        }
        if (stage === 1) {
            return !homeType
        }
        if (stage === 2) {
            return !insulationArea
        }
        if (stage === 3) {
            return atticInsulationType.length === 0;
        }
        if (stage === 4) {
            return wallInsulationType.length === 0;
        }
        if (stage === 5) {
            return !eircode
        }
        if (stage === 6) {
            return !firstName || !lastName
        }
        if (stage === 7) {
            return !email
        }
        if (stage === 8) {
            return !phone
        }
    }

    return (
        <>
        {loading ? (
            <Grid container justifyContent='flex-start'>
                <Grid item xs={12}>
                    <Box display='flex' justifyContent='center' alignItems='center' style={{height: '100vh'}}>
                        <Calculating 
                            message='Finding the best insulation installer in your area...'
                        />
                    </Box>
                </Grid>
            </Grid>
        ) : (
            <>
            {invalid ? (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '100vh'}}>
                            <Invalid 
                                reason={invalidReason}
                            />
                        </Box>
                    </Grid>
                </Grid>
            ): (
            <form ref={dcForm} onSubmit={(e) => e.preventDefault()} style={{height: '100vh', padding: '2%'}} className='energyefficiency'>
                <Grid container justifyContent='center' className='progress-bar-container scroll-container'>
                    <Grid xs={11}>
                        <ProgressBar animated variant='success' now={calculateFormProgress(stage, 8, 7)} />
                    </Grid>
                </Grid>
                <Grid container justifyContent='center' className='question-container scroll-container'>
                    <Grid xs={10} className='question'>
                        {stage === 0 &&
                            <OptionsQuestion 
                                question='When was your home built?'
                                answer={homeBuilt}
                                updateAnswer={(homeBuilt) => setHomeBuilt(homeBuilt)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                options={[
                                    {value: 'Before 2011', label: 'Before 2011', disabled: false, img: Before2011},
                                    {value: 'After 2011', label: 'After 2011', disabled: false, img: After2011}
                                ]}
                            />
                        }
                        {stage === 1 &&
                            <OptionsQuestion 
                                question='What type of house do you have?'
                                answer={homeType}
                                updateAnswer={(homeType) => setHomeType(homeType)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                options={[
                                    {value: 'Terraced house', label: 'Terraced house', disabled: false, img: TerracedHouse},
                                    {value: 'Detached house', label: 'Detached house', disabled: false, img: DetachedHouse},
                                    {value: 'Semi-detached house', label: 'Semi-detached house', disabled: false, img: SemiDetached},
                                    {value: 'Apartment', label: 'Apartment', disabled: false, img: Apartment}
                                ]}
                            />
                        }
                        {stage === 2 &&
                            <OptionsQuestion 
                                question='What type of insulation are you looking for?'
                                answer={insulationArea}
                                updateAnswer={(insulationArea) => setInsulationArea(insulationArea)}
                                nextStage={(answer) => nextStage(answer)}
                                site='energyefficiency'
                                options={[
                                    {value: 'Attic insulation', label: 'Attic insulation', disabled: false, img: AtticInsulation},
                                    {value: 'Wall insulation', label: 'Wall insulation', disabled: false, img: WallInsulation},
                                    {value: 'Attic & wall insulation', label: 'Attic & wall insulation', disabled: false, img: AtticWallInsulation},
                                    {value: 'Not sure yet', label: 'Not sure yet', disabled: false, img: Unsure}
                                ]}
                            />
                        }
                        {stage === 3 &&
                            <OptionsQuestion 
                                question='What type of attic insulation are you interested in?'
                                subtext='Select all that apply'
                                answer={atticInsulationType}
                                updateAnswer={(value) => {
                                    if (atticInsulationType.includes(value)) {
                                        setAtticInsulationType(atticInsulationType.filter(item => item !== value));
                                    } else {
                                        setAtticInsulationType([...atticInsulationType, value]);
                                    }
                                }}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                options={[
                                    {value: 'Spray foam insulation', label: 'Spray foam insulation', disabled: false, img: SprayFoam, subtext: 'Applied as a liquid that expands and hardens'},
                                    {value: 'Roll-out insulation', label: 'Roll-out insulation', disabled: false, img: RollOut, subtext: 'Fiberglass laid out between joists, most cost effective'}
                                ]}
                                multiselect
                            />
                        }
                        {stage === 4 &&
                            <OptionsQuestion 
                                question='What type of wall insulation are you interested in?'
                                subtext='Select all that apply'
                                answer={wallInsulationType}
                                updateAnswer={(value) => {
                                    if (wallInsulationType.includes(value)) {
                                        setWallInsulationType(wallInsulationType.filter(item => item !== value));
                                    } else {
                                        setWallInsulationType([...wallInsulationType, value]);
                                    }
                                }}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                options={[
                                    {value: 'Cavity wall insulation', label: 'Cavity wall insulation', disabled: false, img: CavityWall, subtext: 'Insulating beads or foam injected into the cavity between two layers of block'},
                                    {value: 'External Wall Insulation', label: 'External Wall Insulation', disabled: false, img: External, subtext: 'Insulation boards fixed to the outside of a home, finished with render'},
                                    {value: 'Internal Insulation (Drylining)', label: 'Internal Insulation (Drylining)', disabled: false, img: Internal, subtext: 'Insulation boards fixed to the inside of the home’s external walls'}
                                ]}
                                multiselect
                            />
                        }
                        {stage === 5 &&
                            <Eircode 
                                eircode={eircode}
                                setEircode={(eircode) => setEircode(eircode)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                hasError={eircodeError}
                            />
                        }
                        {stage === 6 &&
                            <Name 
                                firstName={firstName}
                                lastName={lastName}
                                setFirstName={(firstName) => setFirstName(firstName)}
                                setLastName={(lastName) => setLastName(lastName)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                            />
                        }
                        {stage === 7 &&
                            <Email 
                                email={email}
                                setEmail={(email) => setEmail(email)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                hasError={emailError}
                            />
                        }
                        {stage === 8 &&
                            <Phone 
                                phone={phone}
                                setPhone={(phone) => setPhone(phone)}
                                nextStage={() => nextStage()}
                                site='energyefficiency'
                                finalStep
                            />
                        }
                    </Grid>
                </Grid>
                <Grid container justifyContent='center' className='bottom-container scroll-container'>
                    <Grid xs={11} display='flex' justifyContent={stage > 0 ? 'space-between' : 'flex-end'} alignItems='center' className='buttons'>
                        {stage > 0 && 
                            <Button variant='outlined' size='large' onClick={() => previousStage()}>Back</Button>
                        }
                        {stage < 8 && 
                            <Button disabled={checkNextDisabled()} variant='contained' size='large' onClick={() => nextStage()}>Next</Button>
                        }
                        {stage === 8 &&
                            <Button disabled={checkNextDisabled()} variant='contained' size='large' onClick={() => submitForm()}>Agree & Submit</Button>
                        }
                    </Grid>
                </Grid>
            </form>
            )}
            </>
        )}
        </>
    )
}